import volunteeringImg1 from "../imgs/icons/programs/volunteer.png";
import tourismImg1 from "../imgs/icons/programs/tourism.png";
import africanImg1 from "../imgs/icons/programs/african.png";
import juniorsImg1 from "../imgs/icons/programs/juniors.png";
import erasmusImg1 from "../imgs/icons/programs/erasmus.png";

const programs = [
  { title: "All Programs", hook: "All" },
  { title: "Volunteering", icon: volunteeringImg1, hook: "Volunteering" },
  { title: "Adventurous & Road trips", icon: tourismImg1, hook: "Roadtrips" },
  { title: "Have a Dream Juniors", icon: juniorsImg1, hook: "Junior Camps" },
  { title: "EU program", icon: erasmusImg1, hook: "EU Programs" },
  // { title: "Special Requests",  icon: exchangeImg1, }
];

export default programs;
